import React from "react";
import { LockClearIcon } from "@/icons/color-icons";
import { CaButton } from "src/admin-panel";

export type ChatSubscribeNowProps = {
  onClickSubscribe: () => void;
  onClickLogIn: () => void;
  firstName: string;
};

export function ChatSubscribeNow({
  onClickSubscribe,
  onClickLogIn,
  firstName,
}: ChatSubscribeNowProps) {
  return (
    <div
      className='flex flex-col items-center justify-center font-sans-serif text-white'
      style={{
        height: "311px",
        background: "radial-gradient(circle, rgba(0,0,0,1) 10%, #ffffff00 60%)",
      }}
    >
      <LockClearIcon />
      <div className='my-5 text-base font-semibold px-5 text-center' style={{ maxWidth: "424px" }}>
        {`To continue chatting with Digital ${firstName} and to access all her exclusive content, subscribe to
        Digital ${firstName}`}
      </div>
      <CaButton size='large' intent='purple' onClick={onClickSubscribe}>
        Subscribe Now
      </CaButton>
      <div className='my-8 text-sm'>
        <span>Already a member?</span>
        <span
          className='mx-1 font-semibold cursor-pointer'
          style={{ textDecoration: "underline" }}
          onClick={onClickLogIn}
        >
          LOG IN
        </span>
        <span>to continue talking to Digital Deb</span>
      </div>
    </div>
  );
}
